import firebase from "firebase/app";
import {serializer} from "@/api/shared/serializer";
import Loader from "@/components/loader/Loader.vue";
import moment from "moment";
import {EventsTypes} from "@/enums/EventsTypes";
import GalleryFolderDlg from "@/views/staff/gallery/GalleryFolderDlg/GalleryFolderDlg.vue";

export default {
  name: 'gallery',
  components: {
    Loader,
    GalleryFolderDlg
  },
  data() {
    return {
      lastCameraRollPhoto: '',
      lastEventPicturesPhoto: '',
      lastStockPhoto: '',
      lastCanvaPhoto: '',
      loading: true
    }
  },
  computed: {
    facilityId() {
      return this.$store.state.authModule.currentFacility;
    },
    galleryFolders() {
      return this.$store.state.galleryModule.galleryFolders;
    }
  },
  async created() {
    await this.getLastPhotoFromGallery();
    await this.getLastPhotoFromEvents();
    await this.getLastPhotoFromStock();
    await this.getLastPhotoFromCanva();
    await this.$store.dispatch("getGalleryFolders");
    this.loading = false;
  },
  methods: {
    async getLastPhotoFromGallery() {
      const fromDate = moment().subtract(1, "month").startOf('day').unix() * 1000;
      const toDate = moment().endOf("day").unix() * 1000;

      await firebase
        .firestore()
        .collection("photos")
        .where("facilityId", "==", this.facilityId)
        .where('isStaff', '==', true)
        .where('createdAt', '>=',  fromDate)
        .where('createdAt','<=',  toDate)
        .orderBy("createdAt", "desc")
        .get()
        .then((querySnapshot) => {
          const photos: any = serializer.querySnapshotToDocuments(querySnapshot).filter((x: any) => !x.folderId).filter((x: any) => !x.isStock);
          this.lastCameraRollPhoto = photos[0]?.image ? photos[0]?.image : require("../../../assets/no-image.jpg");
        })
    },
    async getLastPhotoFromEvents() {
      const fromDate = moment().subtract(1, "month").startOf('day').toDate();
      const toDate = moment().endOf("day").toDate();

      await firebase
        .firestore()
        .collection("calender")
        .where("facilityId", "==", this.facilityId)
        .where("start", ">", fromDate)
        .where("start", "<", toDate)
        .where("type", "in", [EventsTypes.ConciergeRequest, EventsTypes.Concierge, EventsTypes.PremiumServices, EventsTypes.LifestylePrograms])
        .get()
        .then((querySnapshot) => {
          let photos: any = serializer.querySnapshotToDocuments(querySnapshot);

          photos = photos.filter((x: any) => {
            if(x?.galleryPhotos && x?.galleryPhotos.length >= 1) {
              return x;
            }
          });

          photos = photos.sort((a: any, b: any) => moment(b.start.seconds * 1000).diff(moment(a.start.seconds * 1000)));

          this.lastEventPicturesPhoto = photos[0]?.galleryPhotos[0]?.photoUrl ? photos[0]?.galleryPhotos[0]?.photoUrl : require("../../../assets/no-image.jpg");
        })
    },
    async getLastPhotoFromStock() {
      const fromDate = moment().subtract(1, "month").startOf('day').unix() * 1000;
      const toDate = moment().endOf("day").unix() * 1000;

      await firebase
        .firestore()
        .collection("photos")
        .where("facilityId", "==", this.facilityId)
        .where("isStock", "==", true)
        .where('createdAt', '>=',  fromDate)
        .where('createdAt','<=',  toDate)
        .orderBy("createdAt", "desc")
        .get()
        .then((data) => {
          const photos: any = serializer.querySnapshotToDocuments(data).sort((a: any, b: any) => moment(b.createdAt).diff(moment(a.createdAt)));
          this.lastStockPhoto = photos[0]?.image ? photos[0]?.image : require("../../../assets/no-image.jpg");
        })
    },
    addFolder() {
      this.$refs.GalleryFolderDlg.open();
    },
    async getLastPhotoFromCanva() {
      const storageRef = firebase.storage().ref();
      const folderRef = storageRef.child(`${this.$store.state.facilityModule.selectedFacility.id}/photos/canva`);

      const listResult = await folderRef.listAll();

      if (listResult.items.length === 0) {
        this.lastCanvaPhoto = require("../../../assets/no-image.jpg");
        return;
      }

      const firstItemRef = listResult.items[0];
      this.lastCanvaPhoto = await firstItemRef.getDownloadURL();
    }
  }
};